export default __webpack_public_path__ + "static/media/start_here.e4d36c1b.svg";